var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "price-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "85%",
            "show-close": false,
            offset: 0,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "befor" }, [
              _c("div", { staticClass: "topCar" }, [
                _c("p", [_vm._v("产品详情及报价维护")]),
                _c(
                  "div",
                  [
                    _c("el-input", {
                      staticStyle: {
                        width: "1.5rem",
                        "margin-right": "0.1rem",
                      },
                      attrs: { placeholder: "产品名称", size: "mini" },
                      on: { change: _vm.searchData },
                      model: {
                        value: _vm.productName,
                        callback: function ($$v) {
                          _vm.productName = $$v
                        },
                        expression: "productName",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "an" }, [
                  _c(
                    "span",
                    { staticClass: "span1", on: { click: _vm.save } },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "span",
                    { staticClass: "span2", on: { click: _vm.closeDialog } },
                    [_vm._v("关闭")]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "cen" }, [
              _c("div", { staticClass: "Le" }, [
                _vm.budget.state > -1
                  ? _c("p", [
                      _vm._v(
                        _vm._s(_vm.stockTypeMap[_vm.budget.state].typeName)
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "Lcen" },
                [
                  _c(
                    "el-table",
                    {
                      ref: "singleTable",
                      staticClass: "table1",
                      attrs: {
                        border: "",
                        data: _vm.tableList,
                        "highlight-current-row": "",
                        size: "mini",
                        "span-method": _vm.objectSpanMethod,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          property: "staydate",
                          label: "使用日期",
                          width: "89",
                          height: "48",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " + _vm._s(scope.row.stayDateStr) + " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "产品名称",
                          width: "160",
                          "show-overflow-tooltip": "",
                          sortable: "",
                          prop: "productName",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "hiddenText",
                                    style:
                                      scope.row.stockId == _vm.chooseStockId
                                        ? "box-shadow: 0px 2px 6px 0px #296776;border: 1px solid #296776;"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scope.row.productName) + " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "cityName",
                          label: "使用城市",
                          width: "60",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "servicedescribe",
                          label: "产品说明",
                          width: "93",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.stockDetail.productDesc)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "单价(原币)",
                          width: "73",
                          sortable: "",
                          prop: "stockPrice",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.status == 0
                                        ? scope.row.stockPrice
                                        : 0
                                    ) +
                                      _vm._s(scope.row.currency) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "单位", width: "42" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.stockDetail.priceList[0]
                                        .priceCompany
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "时长", width: "46" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.stockDetail.priceList[0]
                                        .timeDesc
                                        ? scope.row.stockDetail.priceList[0]
                                            .timeDesc
                                        : scope.row.stockDetail.priceList[0]
                                            .useTime
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "servicenumber",
                          label: "数量",
                          width: "38",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.orderBudgetId
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.stockNumber) +
                                          " "
                                      ),
                                    ])
                                  : _c("div", [
                                      (scope.row.status == 0 ? true : false)
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: scope.row.stockNumber,
                                                expression:
                                                  "scope.row.stockNumber",
                                              },
                                            ],
                                            staticStyle: {
                                              width: "0.29rem",
                                              "font-size": "0.12rem",
                                              border: "none",
                                            },
                                            attrs: { type: "number" },
                                            domProps: {
                                              value: scope.row.stockNumber,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeNumber(
                                                  scope.row
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  scope.row,
                                                  "stockNumber",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "address",
                          label: "总价(原币)",
                          width: "65",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.status == 0
                                        ? Number(
                                            (
                                              scope.row.stockNumber *
                                              scope.row.stockPrice
                                            ).toFixed(2)
                                          )
                                        : 0
                                    ) +
                                    _vm._s(scope.row.currency) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      (_vm.budget.currency === "￥" ? false : true)
                        ? _c("el-table-column", {
                            attrs: {
                              property: "rate",
                              label: "汇率",
                              width: "35",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      (scope.row.status == 0 ? true : false)
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: scope.row.rate,
                                                expression: "scope.row.rate",
                                              },
                                            ],
                                            staticStyle: {
                                              width: "0.29rem",
                                              "font-size": "0.12rem",
                                              border: "none",
                                            },
                                            domProps: { value: scope.row.rate },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeRate(scope.row)
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  scope.row,
                                                  "rate",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2765417787
                            ),
                          })
                        : _vm._e(),
                      (_vm.budget.currency === "￥" ? false : true)
                        ? _c("el-table-column", {
                            attrs: {
                              property: "address",
                              label: "总价(人民币)",
                              width: "78",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (scope.row.status == 0
                                              ? scope.row.stockNumber *
                                                scope.row.stockPrice *
                                                scope.row.rate
                                              : 0
                                            ).toFixed(2)
                                          ) + "￥"
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1612566852
                            ),
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          label: "票据号",
                          width: "78",
                          sortable: "",
                          prop: "stockDetail.billNumber",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.stockDetail.billNumber)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "address",
                          label: "操作",
                          width: "126",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [
                                        _c("svg-icon", {
                                          staticClass: "zp",
                                          attrs: {
                                            iconClass:
                                              scope.row.status == 0
                                                ? "eye-close"
                                                : "eye-open",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.Conversionstatus(
                                                scope.$index,
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [
                                        !scope.row.orderBudgetId
                                          ? _c("i", {
                                              staticClass: "el-icon-delete zp",
                                              staticStyle: { color: "#2C2C2C" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteBudget(
                                                    scope.row,
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "zp1",
                                            on: {
                                              click: function ($event) {
                                                return _vm.chaifen(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("拆")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      { attrs: { type: "text" } },
                                      [
                                        !scope.row.orderBudgetId
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "zp1",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.singleCreateOrder(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("订")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "lfoot" }, [
                    _c("div", { staticClass: "pbian" }, [
                      _c("p", [_vm._v("合计")]),
                    ]),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c("div", { staticClass: "lfootC" }, [
                        _c(
                          "p",
                          { staticClass: "lfootCP1" },
                          _vm._l(_vm.numPrice, function (item, index) {
                            return _c(
                              "span",
                              { key: index, staticClass: "cp2" },
                              [
                                _vm._v(
                                  _vm._s(item.price) + _vm._s(item.currency)
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _c("div", { staticClass: "lfootR" }, [
                        _c("p", [
                          _c(
                            "span",
                            { staticClass: "p1235" },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  width: "0.18rem",
                                  height: "0.18rem",
                                },
                                attrs: { iconClass: "kefu" },
                              }),
                              _c("span", { staticClass: "p1" }, [
                                _vm._v("总额"),
                              ]),
                              _c("span", { staticClass: "variety" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      "￥" + Number(_vm.sumPrice.toFixed(2))
                                    )
                                ),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "p3",
                                  on: { click: _vm.allCreateOrder },
                                },
                                [_vm._v("预 订")]
                              ),
                            ],
                            1
                          ),
                          _c("button", { staticClass: "p4" }, [
                            _c("div", [_vm._v("查看优惠卷")]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "Rig" }, [
                _c(
                  "div",
                  { staticClass: "slider" },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "table2",
                        attrs: {
                          data: _vm.tableList,
                          "cell-style": _vm.rowStyle,
                          "header-cell-style": _vm.tableHeaderColor,
                        },
                      },
                      [
                        _vm._v("> "),
                        _c("el-table-column", {
                          attrs: {
                            property: "companyname",
                            label: "单项报价(原币)",
                            width: "90",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return (scope.row.status == 0 ? true : false)
                                    ? [
                                        !scope.row.orderBudgetId
                                          ? _c("div", [
                                              _c("input", {
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    scope.row.status == 0
                                                      ? scope.row.ratio
                                                      : 0,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeNum(
                                                      $event,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.currency) +
                                                  " "
                                              ),
                                              scope.$index == 0
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-document-copy",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.copyPrice(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.ratio) +
                                                  _vm._s(scope.row.currency) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            property: "companyname",
                            label: "单项利润(原币)",
                            width: "75",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return (scope.row.status == 0 ? true : false)
                                    ? [
                                        !scope.row.orderBudgetId
                                          ? _c("div", [
                                              _c("input", {
                                                attrs: { type: "number" },
                                                domProps: {
                                                  value:
                                                    scope.row.status == 0
                                                      ? Number(
                                                          (
                                                            scope.row.ratio -
                                                            scope.row.stockPrice
                                                          ).toFixed(2)
                                                        )
                                                      : 0,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.profit(
                                                      $event,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    Number(
                                                      (
                                                        scope.row.ratio -
                                                        scope.row.stockPrice
                                                      ).toFixed(2)
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            property: "yb",
                            label: "单项利(润率)",
                            width: "59",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return (scope.row.status == 0 ? true : false)
                                    ? [
                                        !scope.row.orderBudgetId
                                          ? _c("div", [
                                              _c("input", {
                                                attrs: { type: "text" },
                                                domProps: {
                                                  value:
                                                    scope.row.status == 0
                                                      ? (
                                                          ((scope.row.ratio -
                                                            scope.row
                                                              .stockPrice) /
                                                            scope.row.ratio) *
                                                          100
                                                        ).toFixed(2)
                                                      : 0,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.profitlv(
                                                      $event,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v("% "),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    (
                                                      ((scope.row.ratio -
                                                        scope.row.stockPrice) /
                                                        scope.row.ratio) *
                                                      100
                                                    ).toFixed(2)
                                                  ) +
                                                  "% "
                                              ),
                                            ]),
                                      ]
                                    : undefined
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        (_vm.budget.currency === "￥" ? false : true)
                          ? _c("el-table-column", {
                              attrs: {
                                property: "zbj",
                                label: "总报价(原币)",
                                width: "85",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (scope.row.status == 0
                                                ? scope.row.ratio *
                                                  scope.row.stockNumber
                                                : 0
                                              ).toFixed(2)
                                            ) + _vm._s(_vm.budget.currency)
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3579047716
                              ),
                            })
                          : _vm._e(),
                        _c("el-table-column", {
                          attrs: {
                            property: "zbj",
                            label: "总报价(人民币)",
                            width: "105",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (scope.row.status == 0
                                            ? scope.row.ratio *
                                              scope.row.rate *
                                              scope.row.stockNumber
                                            : 0
                                          ).toFixed(2)
                                        ) +
                                        "￥ "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            property: "zlr",
                            label: "总利润(人民币)",
                            width: "71",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        (scope.row.status == 0
                                          ? scope.row.ratio *
                                              scope.row.rate *
                                              scope.row.stockNumber -
                                            scope.row.stockNumber *
                                              scope.row.stockPrice *
                                              scope.row.rate
                                          : 0
                                        ).toFixed(2)
                                      ) + "￥"
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "silafter" }, [
                  _c(
                    "div",
                    { staticClass: "afL" },
                    _vm._l(_vm.Totaloffer, function (item, index) {
                      return _c("span", { key: index, staticClass: "s3" }, [
                        _vm._v(
                          _vm._s(item.price.toFixed(2)) + _vm._s(item.currency)
                        ),
                      ])
                    }),
                    0
                  ),
                  _c("div", { staticClass: "afC" }, [
                    _c("div", [
                      _c("span", { staticClass: "s1" }, [
                        _vm._v(_vm._s(_vm.TotalofferRmb.toFixed(2))),
                      ]),
                      _c("span", { staticClass: "s2" }, [_vm._v("￥")]),
                    ]),
                    _c("div", [
                      _c("span", { staticClass: "s4" }, [_vm._v(" 报价")]),
                    ]),
                  ]),
                  _c("div", { staticClass: "afR" }, [
                    _c("div", [
                      _c("span", { staticClass: "s4" }, [_vm._v("利润 ")]),
                      _c("span", { staticClass: "sm1" }, [
                        _vm._v(
                          _vm._s((_vm.TotalofferRmb - _vm.sumPrice).toFixed(2))
                        ),
                      ]),
                      _c("span", { staticClass: "s6" }, [_vm._v("￥")]),
                    ]),
                    _c("div", [
                      _c("span", { staticClass: "s4" }, [_vm._v("利润率 ")]),
                      _c("span", { staticClass: "s5" }, [
                        _vm._v(
                          _vm._s(
                            (
                              ((_vm.TotalofferRmb - _vm.sumPrice) /
                                _vm.TotalofferRmb) *
                              100
                            ).toFixed(2)
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "s2" }, [_vm._v("%")]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm.productStockList.length > 0
              ? _c(
                  "div",
                  { staticClass: "after" },
                  [
                    _c("svg-icon", {
                      staticClass: "zpleft",
                      staticStyle: { left: "0" },
                      attrs: { iconClass: "arrowhead-left" },
                    }),
                    _c("svg-icon", {
                      staticClass: "zpleft",
                      staticStyle: { right: "0" },
                      attrs: { iconClass: "arrowhead-right" },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          margin: "0.26rem 0.17rem 0.2rem 0.43rem",
                          display: "flex",
                        },
                      },
                      _vm._l(_vm.productStockList, function (pp, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "Lbox",
                            style:
                              pp.id == _vm.chooseStockId
                                ? "box-shadow: 0px 2px 6px 0px #296776;border: 1px solid #296776;"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.changeStock(pp)
                              },
                            },
                          },
                          [
                            _c("stock-detail", {
                              attrs: {
                                stockDetailObj: pp,
                                productType:
                                  _vm.budget.productType == 1 ||
                                  _vm.budget.productType == 5
                                    ? 1
                                    : 2,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _c("createPreOrder", { ref: "orderPre" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }